export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6779.e50e123c.jpg";